// Service for the Attendance Dashboard "Mi equipo" "Resumen del mes" filters panel
// (ASIS-5414).
// GET /attendance/my-team/monthly-summary/monthly-cutoffs?cutoffCompanyId=1 — monthly
// cutoffs available for the selected company, most recent first (backend-ordered).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetMyTeamMonthlyCutoffsListOut,
  GetMyTeamMonthlyCutoffsParams,
  MyTeamMonthlyCutoff,
} from '../types/myTeamMonthlyCutoffs.types';
import { mapMyTeamMonthlyCutoffsList } from '../mappers/myTeamMonthlyCutoffs.mapper';


export class MyTeamMonthlyCutoffsService {
  async getMonthlyCutoffs(
    params: GetMyTeamMonthlyCutoffsParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamMonthlyCutoff[]>> {
    const query = buildQueryString({ cutoffCompanyId: params.cutoffCompanyId });
    const response = await apiClient.get<LC_GetMyTeamMonthlyCutoffsListOut>(
      `${API_CONFIG.ENDPOINTS.ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_MONTHLY_CUTOFFS}${query}`,
      { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamMonthlyCutoffsList(response.data) };
  }
}

export const myTeamMonthlyCutoffsService = new MyTeamMonthlyCutoffsService();
